import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// types
import { Modals } from 'constants/index'
import { AttachmentType, Attachment } from './types'

type FieldInput = { value: any; onChange: (v: any) => void; name: string }

export const useAttachmentField = ({
  input,
  form,
  onAfterClear,
  onAfterLinkSet,
}: {
  input: FieldInput
  form: string
  onAfterClear?: () => void
  onAfterLinkSet?: () => void
}) => {
  const dispatch = useDispatch()

  const { showModal } = useShowModal({ modalType: Modals.ADD_LINK_FOR_ACTIVITY_MODAL })

  const [attachment, setAttachment] = React.useState<Attachment | null>(input.value || null)

  React.useEffect(() => {
    if (!input.value?._pending) {
      setAttachment(input.value || null)
    }
  }, [input.value])

  const setValue = (value: Attachment | null) => {
    setAttachment(value)
    dispatch(change(form, input.name, value))
  }

  const clearField = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setValue(null)
    onAfterClear?.()
  }

  const showAddLinkModal = () => {
    showModal({
      handleConfirm: async (data: { linkName?: string; linkTarget: string }) => {
        setValue({ title: data.linkName, url: data.linkTarget, type: AttachmentType.Link })
        onAfterLinkSet?.()
      }
    })
  }

  return { attachment, setAttachment, setValue, clearField, showAddLinkModal }
}
